import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-disclosure-indicator',
    templateUrl: './disclosure-indicator.component.html',
    styleUrls: ['./disclosure-indicator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisclosureIndicatorComponent {
  @Input() isExpanded: boolean = false;
  @Input() color: string | undefined;
}
